const isChatIframed = () => window.self !== window.top;

export default isChatIframed;
